import ajax from '@/lib/ajax'
import {AxiosResponse} from 'axios'
import UserLoginInfo from '@/store/models/userLoginInfo'
import cookie from 'js-cookie'
// identity server 认证
class Oidc {
	// 发现端点
	async openidConfiguration() {
		return await ajax.get<IOpenidConfiguration>('/.well-known/openid-configuration').then(rep=> {
			console.log(rep.data)
			return rep.data
		})
	}
	async authorize() {
		let config = await this.openidConfiguration()
		if(!config) return
		await ajax.get(config.authorization_endpoint).then(rep=> {
			console.log(rep.data)
		})
	}
	// 调用token endpoint
	async token(setting: TokenSetting) {
		let config = await this.openidConfiguration()
		if(!config) return
		// let ps = {
		// 	client_id: 'Esm_App',
		// 	client_secret: '1q2w3e*',
		// 	grant_type: 'password',
		// 	scope: 'Esm',
		// 	username: 'admin',
		// 	password: '1q2w3E*'
		// }
		// let p = new URLSearchParams(setting)
		// return await ajax.post<TokenResult>(config.token_endpoint, p, { headers:{'Content-Type':'application/x-www-form-urlencoded'} }).then(rep=> {
		// 	console.log('get token success', rep.data)
		// 	return rep.data
		// })
	}
	// 密码模式获取token
	async tokenWithPasswordType(username: string, password: string) {
		if(!username)
			return Promise.reject(new Error('username is required'))
		if(!password)
			return Promise.reject(new Error('password is required'))
		let config = await this.openidConfiguration()
		if(!config) return
		let s = {
			client_id: 'Esm_App',
			client_secret: '1q2w3e*',
			grant_type: 'password',
			scope: 'Esm',
			username,
			password
		}
		let p = new URLSearchParams(s)
		return await ajax.post<TokenResult>(config.token_endpoint, p, { headers:{'Content-Type':'application/x-www-form-urlencoded'} }).then(rep=> {
			console.log('get token success', rep.data)
			return rep.data
		})
	}
	// 用户登录，登录后会设置cookie
	async login(info: UserLoginInfo) {
		if(!info.userNameOrEmailAddress)
			return Promise.reject(new Error('请输入用户名'))
		if(!info.password)
			return Promise.reject(new Error('请输入密码'))
		let token = await this.tokenWithPasswordType(info.userNameOrEmailAddress, info.password)
		if(!token) return
		cookie.set('access_token', token.access_token, { expires: token.expires_in})
		cookie.set('token_type', token.token_type, {expires: token.expires_in})
	}
	// 检查当前是否已授权
	isAuthorization() {
		let token = cookie.get('access_token')
		if(token) return true
		return false
	}
}

const oidc = new Oidc()
export default oidc

interface IOpenidConfiguration {
	issuer: string
	jwks_uri: string
	authorization_endpoint: string
	token_endpoint: string
	userinfo_endpoint: string
	end_session_endpoint: string
	check_session_iframe: string
	revocation_endpoint: string
	introspection_endpoint: string
	device_authorization_endpoint: string
	frontchannel_logout_supported: boolean
	frontchannel_logout_session_supported: boolean
	backchannel_logout_supported: boolean
	backchannel_logout_session_supported: boolean
	request_parameter_supported: boolean
	scopes_supported: Array<string>
	claims_supported: Array<string>
	grant_types_supported: Array<string>
	response_types_supported: Array<string>
	response_modes_supported: Array<string>
	token_endpoint_auth_methods_supported: Array<string>
	id_token_signing_alg_values_supported: Array<string>
	subject_types_supported: Array<string>
	code_challenge_methods_supported: Array<string>
}
class AuthorizeInput {
	client_id: string = ''
	request: string = ''
	request_uri: string = ''
	scope: string = ''
	redirect_uri: string = ''
	response_type: string = ''
	response_mode: string = 'form_post'
	state: string = ''
	nonce: string = ''
}
interface ITokenSetting {
	client_id: string
	client_secret: string
	grant_type: string
}
// 请求 token endpoint 的入参
class TokenSetting implements ITokenSetting {
	constructor(client_id: string, client_secret: string, grant_type: string) {
		this.client_id = client_id
		this.client_secret = client_secret
		this.grant_type = grant_type
	}
	client_id: string
	client_secret: string
	grant_type: string
}
// 请求 token endpoint 的返回结果
interface TokenResult {
	access_token: string
	expires_in: number
	token_type: string
	scope: string
}
